export class ApiConstants
{
    public static mediumODataTop = 50;
    public static largeODataTop = 2000;
}
